/* stylelint-disable max-nesting-depth */

.uic-multiline-input {
    box-sizing: border-box;
    display: flex;
    flex-flow: column nowrap;
    position: relative;
    padding: 2px 8px 8px;

    &__label {
        overflow: hidden;
        color: var(--uic-color-black);
        font-size: var(--uic-font-size-normal);
        line-height: var(--uic-line-height-normal);
        text-overflow: ellipsis;
    }

    &.uic-multiline-input--has-label {
        padding: 2px 8px 8px;

        .uic-multiline-input__label {
            display: block;
            padding-bottom: 4px;
        }
    }

    &__container {
        position: relative;
        display: flex;
        box-sizing: border-box;
        border: 1px solid var(--uic-color-grey2);
        background: var(--uic-color-white);

        &:hover {
            border-color: var(--uic-color-blue2);
            color: var(--uic-color-blue3);
        }

        &:active {
            border: 1px solid var(--uic-color-blue2);
            color: var(--uic-color-blue3);
            background: var(--uic-color-blue2a10);
        }
    }

    &.uic-multiline-input--focused {
        .uic-multiline-input__container {
            outline-offset: -2px;
            outline: 2px solid var(--uic-color-blue2);
            color: var(--uic-color-black);
        }
    }

    &__control {
        --uic-multiline-input-padding-adjustment: calc(
            8px -
                (
                    var(--uic-line-height-medium) -
                        (
                            var(--uic-multiline-height-of-single-line-input) - 2 *
                                8px
                        )
                )
        );

        @include font(medium, semibold);
        display: block;
        box-sizing: border-box;
        width: 100%;
        height: 100%;
        flex: 1 1 auto;
        background: transparent;
        border: 0;
        border-radius: 0;
        margin: 0;
        padding: var(--uic-multiline-input-padding-adjustment) 8px;
        outline: none;
        color: inherit;
        resize: none;
        caret-color: var(--uic-color-blue2);

        &::placeholder {
            color: var(--uic-color-grey3a50);
            font-weight: normal;
        }

        &::selection {
            background-color: var(--uic-color-blue2);
            color: var(--uic-color-white);
            line-height: 24px;
        }

        &::selection {
            background-color: var(--uic-color-blue2);
            color: var(--uic-color-white);
        }

        &:disabled::selection {
            background-color: transparent;
            color: inherit;
        }
    }

    &__flag {
        position: absolute;
        display: none;
        top: 2px;
        right: 4px;
    }

    &__helper-text {
        overflow: hidden;
        color: var(--uic-color-black);
        font-size: 0.8rem;
        line-height: 1.3rem;
        text-overflow: ellipsis;

        &-inner {
            @include truncate();
        }
    }

    &.uic-multiline-input--has-helper-text {
        padding-bottom: 1px;

        .uic-multiline-input__helper-text {
            margin-top: 3px;
        }
    }

    &--invalid {
        .uic-multiline-input {
            &__helper-text {
                color: var(--uic-color-red1);
            }
        }
    }

    &--flag {
        .uic-multiline-input {
            &__flag {
                display: block;
            }

            &__control {
                padding-right: 44px;
            }
        }
    }

    &--disabled {
        pointer-events: none;

        .uic-multiline-input__control {
            border-color: var(--uic-color-grey2a25);
            background-color: var(--uic-color-white);
            color: var(--uic-color-blacka50);
            font-weight: var(--uic-font-weight-normal);
        }
    }
}

@media #{$breakpoint_tablet} {
    .uic-multiline-input {
        --uic-multiline-height-of-single-line-input: 40px;
    }
}

@media #{$breakpoint_desktop} {
    .uic-multiline-input {
        --uic-multiline-height-of-single-line-input: 48px;
    }
}

@media #{$breakpoint_tablet_small} {
    .uic-multiline-input {
        --uic-multiline-height-of-single-line-input: 30px;
    }
}
